import { render, staticRenderFns } from "./TopBrowsersTableCard.vue?vue&type=template&id=90db0616&scoped=true&"
import script from "./TopBrowsersTableCard.vue?vue&type=script&lang=ts&"
export * from "./TopBrowsersTableCard.vue?vue&type=script&lang=ts&"
import style0 from "./TopBrowsersTableCard.vue?vue&type=style&index=0&id=90db0616&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90db0616",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VContainer,VDataTable,VIcon,VImg,VRow})
